import { Configuration, LogLevel, BrowserCacheLocation } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { environment } from 'environments/environment';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: '2568cd0c-d5a2-4571-845d-e5c7dea54707',
    authority: 'https://login.microsoftonline.com/e5175381-be76-4d1c-b8e8-9c9e6d75972e',
    // redirectUri: 'http://localhost:4200',
    redirectUri: environment.redirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true
  },
  system: {
    allowNativeBroker: false, // Disable native broker
    loggerOptions: {
      logLevel: LogLevel.Verbose
    }
  }
};

// Guard configuration for protected routes
export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: [ 'api://2568cd0c-d5a2-4571-845d-e5c7dea54707/access_as_user']
  }
};

// HTTP interceptor configuration for adding tokens to API requests
export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map([
    [`${environment.apiURLEndpoint}api/msal-login`, null],
    [environment.apiURLEndpoint, ['api://2568cd0c-d5a2-4571-845d-e5c7dea54707/access_as_user']]
  ])
};
